import ReducerUtils   from "../../../utils/ReducerUtils"
import Actions        from "../../../model/constant/actions"

const RetrievingPacyV0Usage = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_PACY_V0USAGE] : (state,action)=>action.status
})

export default RetrievingPacyV0Usage
